import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../api';

export interface ILicenseContent {
  ticketId: string;
  url: string;
  baseURL: string | undefined;
}

export const licenseContentThunk = createAsyncThunk(
  'license-content',
  async (licenseContent: ILicenseContent, { rejectWithValue }) => {
    try {
      return await Api.post(
        licenseContent.url,
        { ticketId: licenseContent.ticketId },
        { baseURL: licenseContent.baseURL }
      );
    } catch (err) {
      const message =
        err.response?.data?.message || // your custom backend message
        err.response?.data || // fallback if backend sends raw string
        err.message || // Axios default message
        'Unknown error';
      console.log(err);
      return rejectWithValue(message);
    }
  }
);
